<template>
  <div>
    <div>
      <div class="c-card-body">
        <datatable
          ref="datatable"
          module="user"
          :title="title"
          :url="url"
          :columns="columns"
          :filter="filter"
          :on-click-create="onClickCreate"
          :on-click-update="onClickUpdate"
          :on-click-delete="onClickDelete"
          :action-width="180"
        >
          <template v-slot:item.action="{ item }">
            <span v-if="!item.active" class="delete-hide-guard" />
          </template>
          <template v-slot:action>
            <v-col md="3">
              <v-select
                label="Role"
                required
                dense
                outlined
                v-model="filterRole"
                :items="listRole"
                item-text="name"
                item-value="slug"
                hide-details="true"
                clearable
              ></v-select>
            </v-col>
            <v-col md="3">
              <v-select
                label="Status"
                dense
                outlined
                v-model="filterStatus"
                :items="listStatus"
                item-text="text"
                item-value="value"
                hide-details="true"
              ></v-select>
            </v-col>
          </template>
          <template v-slot:[`item.username`]="{ item }">
            <div style="width: 100px">
              {{ item.username }}
            </div>
          </template>
          <template v-slot:[`item.name`]="{ item }">
            <div style="width: 100px">
              {{ item.name }}
            </div>
          </template>
          <template v-slot:[`item.name`]="{ item }">
            <div style="width: 100px">
              {{ item.name }}
            </div>
          </template>
          <template v-slot:item.active="{ item }">{{
            item.active ? "Aktif" : "Tidak Aktif"
          }}</template>
        </datatable>
      </div>
    </div>
    <form-user ref="form" module="user" :success="formSuccess" />
    <delete-dialog
      ref="delete"
      url="user"
      :success="deleteSuccess"
    ></delete-dialog>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Datatable from "@/view/component/Datatable.vue";
import DeleteDialog from "@/view/component/DeleteDialog.vue";
import FormUser from "./FormUser";
import ApiService from "@/core/services/api.service";

export default {
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Manajemen User", route: "" },
      { title: "User" }
    ]);

    const { data } = await ApiService.get("role/list");
    this.listRole = data;

    // Cari ID role 'member'
    const memberRole = data.find((r) => r.name.toLowerCase() === "member");
    if (memberRole) {
      this.excludedRoleId = memberRole.id;
    }

    this.listRole = data.filter(r => r.name.toLowerCase() !== "member");

    this.buildFilter();

  },
  data() {
    return {
      title: "User",
      url: "user/data",
      columns: [
        {
          value: "id"
        },
        {
          text: "Username",
          value: "username",
          sortable: true,
          searchable: true
        },
        {
          text: "Nama Lengkap",
          value: "name",
          sortable: true,
          searchable: true
        },
        {
          text: "Email",
          value: "email",
          sortable: true,
          searchable: true
        },
        {
          text: "Role",
          value: "active_role_list",
          sortable: true,
          searchable: false
        },
        {
          text: "Status",
          value: "active",
          sortable: true,
          searchable: false
        },
        {
          text: "Tanggal Mulai Bekerja",
          value: "start_working_date",
          sortable: true,
          searchable: false
        }
      ],
      listRole: [],
      filterRole: null,
      listStatus: [
        { text: "Semua", value: "all" },
        { text: "Aktif", value: true },
        { text: "Tidak Aktif", value: false }
      ],
      filterStatus: "all",
      filter: null,
      excludedRoleId: null
    };
  },
  methods: {
    buildFilter() {
      const filters = [];

      if (this.excludedRoleId) {
        filters.push({
          column: "start_working_date",
          value: null,
          operator: "ne"
        });
      }

      if (this.filterRole) {
        filters.push({
          column: "active_role_list",
          value: this.filterRole,
          operator: "contains"
        });
      }

      filters.push({
        column: "active",
        value: this.filterStatus,
        operator: "eq"
      });

      this.filter = filters.length ? filters : null;
    },
    onClickCreate() {
      this.$refs.form.open();
    },
    onClickUpdate(item) {
      this.$refs.form.open(item.id);
    },
    onClickDelete(item) {
      if (!item.active) {
        return;
      }
      this.$refs.delete.open(item.id);
    },
    formSuccess() {
      this.$refs.datatable.getData();
    },
    deleteSuccess() {
      this.$refs.datatable.getData();
    }
  },
  watch: {
    filterRole() {
      this.buildFilter();
    },
    filterStatus() {
      this.buildFilter();
    }
  },
  components: {
    Datatable,
    DeleteDialog,
    FormUser
  }
};
</script>

<style scoped>
::v-deep td .delete-hide-guard ~ div .v-btn.error {
  display: none !important;
}
</style>
